import { experimentalMutate } from '@confluence/legacy-schema-bridge/entry-points/experimentalMutate.ts';
import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
import { BadStatusError, getTraceIdFromResponse } from '@confluence/network';
import { getErrorWithResponse } from '@confluence/graphql/entry-points/getErrorWithResponse.ts';
import type {
	ExperimentalResetCollabService,
	ExperimentalResetCollabServiceVariables,
} from './__types__/ExperimentalResetCollabService.ts';

export const experimentalResetCollabServiceMutate = ({
	variables,
}: {
	variables: ExperimentalResetCollabServiceVariables;
}) => {
	return experimentalMutate<
		ExperimentalResetCollabService,
		ExperimentalResetCollabServiceVariables,
		ExperimentalResetCollabServiceMutationResponse
	>({
		url: `/wiki/rest/collab/1.0/content/${variables.contentId}/reset?behind=${variables.behind || 'COLLAB'}`,
		method: 'PUT',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		variables,
		parseResponseOnSuccess: (response) => ({
			traceId: getTraceIdFromResponse(response) ?? '',
		}),
		parseResult: (response) => ({
			experimentalResetCollabService: {
				traceId: response.traceId,
			},
		}),
	}).catch(async (error) => {
		const response = error instanceof BadStatusError ? error.response : undefined;
		if (response) {
			throw getErrorWithResponse(error, response);
		}
		throw error;
	});
};

interface ExperimentalResetCollabServiceMutationResponse {
	traceId: string;
}
